let ta = null;

export default function decode_html_entities (str) {
  if (ta === null) {
    ta = document.createElement('textarea');
  }
  ta.innerHTML = str;
  return ta.value;
}
